import { underscore } from 'inflected';

export const ASSET_CATEGORY_LABELS = {
	'av': 'Audio/Visual',
	'print': 'Print',
	'creative': 'Creative',
	'documents': 'Documents',
	'digital': 'Digital'
};

export const ASSET_TYPES_GROUPS = [
	{ label: 'AV', value: 'av' },
	{ label: 'Print', value: 'print' },
	{ label: 'Digital', value: 'digital' },
	{ label: 'Documents', value: 'documents' }
];

export const ASSET_TYPES_CATEGORIES = [
	{ label: 'AV', value: 'av' },
	{ label: 'Print', value: 'print' },
	{ label: 'Documents', value: 'documents' }
];

// Assets with no type belong to the project itself.
const NO_TYPE_LABEL = 'Project';

// `inflected`'s `humanize` reads its rules off a plain object, so `humanize('constructor')` returns
// the `Object` constructor. Humanizing a slug only needs its words and a capital. A dot separates
// variants, as in the legacy labels (`trailer.us` is "Trailer - US"), so it reads as " - ".
const humanizeSlug = (slug) => {
	const words = slug
		.split('.')
		.map((part) => underscore(part).replace(/_/g, ' ')
			.trim())
		.filter(Boolean)
		.join(' - ');
	return words.charAt(0).toUpperCase() + words.slice(1);
};

/**
 * Resolves the label to display for an asset type.
 *
 * The label an admin set on the type wins (on the record, or in `labels` when only the slug is at
 * hand); a type without one reads as its humanized slug, so a brand new type is still readable.
 * The labels that used to be hardcoded here are seeded into the database by the PLATFORM-4128
 * migration.
 *
 * @param {object|string} type an asset type record (`{ name, label }`) or a bare slug
 * @param {object} labels slug to label map, from `useAssetTypeLabels()` when only a slug is at hand
 */
export const assetTypeLabel = (type, labels = {}) => {
	const isRecord = typeof type === 'object' && type !== null;
	const slug = isRecord ? type.name : type;

	if(slug === undefined || slug === null) {
		return slug;
	}

	// Own keys only: a slug such as `constructor` must not resolve to `Object.prototype` members.
	// `Object.hasOwn` would do, but the build targets Chrome 81, which lacks it.
	const lookup = (map) => (map && Object.prototype.hasOwnProperty.call(map, slug) ? map[slug] : null);
	// A label of only spaces would render blank, so it falls through to the next source.
	const present = (label) => (typeof label === 'string' && label.trim() ? label.trim() : null);

	return present(isRecord ? type.label : null)
		|| present(lookup(labels))
		|| (slug ? humanizeSlug(slug) : NO_TYPE_LABEL);
};